import React from 'react';
import PropTypes from 'prop-types';
import "./ajaxSpinner.scss";
import CommonAppSetup from '../../common/common-app-setup/CommonAppSetup';
import Components from '../../common/Components';
import joinClassNames from "../../common/JoinClassNames";
import backdrops from './AjaxSpinnerBackdrop';
import AriaLiveContext from '../aria-live/AriaLiveContext';

const propTypes = {
	ariaPoliteMessage: PropTypes.string,
	ariaAssertiveMessage: PropTypes.string,
	backdropType: PropTypes.string,
	className: PropTypes.string,
	labelAnimated: PropTypes.bool,
	labelName: PropTypes.string,
	numSquares: PropTypes.number,
	size: PropTypes.number,
	time: PropTypes.number,
};

const defaultProps = {
	ariaPoliteMessage: undefined,
	ariaAssertiveMessage: undefined,
	backdropType: backdrops.NONE,
	className: '',
	labelAnimated: false,
	labelName: undefined,
	numSquares: 12,
	size: undefined,
	time: 0.5,
};

export default class AjaxSpinner extends React.Component {
	componentDidMount() {
		const { addAriaLiveAssertiveMessage, addAriaLivePoliteMessage } = this.context;
		if (this.props.ariaAssertiveMessage) {
			addAriaLiveAssertiveMessage(this.props.ariaAssertiveMessage);
		}
		if (this.props.ariaPoliteMessage) {
			addAriaLivePoliteMessage(this.props.ariaPoliteMessage);
		}
	}
	
	getLabel() {
		let classNames = 'hcenter vcenter';
		classNames += this.props.labelAnimated ? ' animated' : '';
		return this.props.labelName ? <label className={joinClassNames(classNames, CommonAppSetup.getClassName(Components.AJAX_SPINNER, 'label'))}>{this.props.labelName}</label> : false;
	}

	getStyle() {
		return this.props.size ? {'width': this.props.size + 'px', 'height': this.props.size + 'px'} : {};
	}

	getClassNames () {
		return joinClassNames(
			'css-spinner',
			this.props.className,
			this.props.backdropType !== AjaxSpinner.BACKDROPS.NONE ? ' hcenter vcenter with-backdrop' : '',
			this.props.backdropType === AjaxSpinner.BACKDROPS.COVER_PAGE ? ' cover-page' : '',
			CommonAppSetup.getClassName(Components.AJAX_SPINNER, 'spinner')
		);
	}

	getBackdrop() {
		let retval = null;
		if (this.props.backdropType !== AjaxSpinner.BACKDROPS.NONE) {
			retval = <div className={joinClassNames(
				'backdrop',
				this.props.backdropType === AjaxSpinner.BACKDROPS.COVER_PAGE ? ' cover-page': '',
				CommonAppSetup.getClassName(Components.AJAX_SPINNER, 'backdrop'))} key="ajaxSpinnerBackdrop"></div>;
		}
		return retval;
	}

	getSquares() {
		let retval = [];
		let deg = (360 / this.props.numSquares);
		let delay = (this.props.time / this.props.numSquares);
		for (let i = 0; i < this.props.numSquares; i++) {
			let squareStyle = {
				transform: 'rotate('+((i*deg)+.001)+'deg) translateX(-50%)',
				animation: 'css-spinner linear '+this.props.time+'s infinite',
				animationDelay: (i*delay) + 's'
			};
			retval.push(<div key={'spinbox'+i} style={squareStyle}></div>);
		}
		return retval;
	}

	render() {
		return (<React.Fragment>
			{this.getBackdrop()}
			<div className={this.getClassNames()} style={this.getStyle()} key="ajaxSpinner">
				{this.getSquares()}
				{this.getLabel()}
			</div>
		</React.Fragment>);
	}
}

AjaxSpinner.BACKDROPS = backdrops;
AjaxSpinner.defaultProps = defaultProps;
AjaxSpinner.propTypes = propTypes;
AjaxSpinner.contextType = AriaLiveContext;
